import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/useAuth';
import { CircularProgress, Box } from '@mui/material';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  console.log(
    'ProtectedRoute - isAuthenticated:',
    isAuthenticated,
    'isLoading:',
    isLoading,
    'user:',
    user
  );

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is admin
  const userType =
    typeof user?.role === 'string' ? user.role : user?.role?.name;
  if (userType !== 'ADMIN') {
    console.log(
      'User is not admin, userType:',
      userType,
      'redirecting to login'
    );
    return <Navigate to="/login" replace />;
  }

  console.log('User is authenticated and is admin, rendering children');
  return <>{children}</>;
};

export default ProtectedRoute;
